import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'PARAM_ENT',
  title: 'Comment modifier les paramètres de mon entreprise ? ',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Pour accéder aux paramètres de votre entreprise cliquez sur l’onglet « Paramètres » :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_PARAM_ENT/FR_PARAM_ENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Vous arrivez ensuite sur la page des paramètres de votre entreprise que vous pouvez consulter. Pour modifier ces paramètres, vous devez en faire la demande au Service Clients en cliquant sur « Contacter le Service Clients » et en effectuant votre demande de modification :'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_PARAM_ENT/FR_PARAM_ENT_2.png`
  }]
};
